<template>
    <div id="wrap" class="skpfull_wrap">
        <div class="rd_box register">
            <div class="container register step3">
				<div class="title">
					<h1>{{$t('TITLE.EUR.SIGNUP.REQUEST')}}</h1>
				</div>
				<div class="content" ng-init="">
					<div class="one-register">

                        <div class="register_step">
                            <ul>
                                <li>
                                    <em>1</em>
                                    <p>{{$t('TITLE.EUR.TERMS')}}</p>
                                </li>
                                <li>
                                    <em>2</em>
                                    <p>{{$t('TITLE.EUR.SIGN.UP')}}</p>
                                </li>
                                <li class="active"><!-- 활성화 STEP class -->
                                    <em>3</em>
                                    <p>{{$t('BUTTON.GLOBAL.REQUEST')}}</p>
                                </li>
                            </ul>
                        </div>

                        <keep-alive>
                            <req-repair-info :bIndependent="false" />
                        </keep-alive>

					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>

import Vue                          from 'vue';
import { mapActions, mapGetters }   from 'vuex';
import { SDLUtil, StringUtil }      from '@/utils';
import qs                           from 'query-string';
import axios                        from 'axios';
import constants                    from '@/constants';
import store                        from '@/vuex/store';
import reqRepairInfo                from '~vb/eur/user/RequestRepairInfo';
import { i18n, loadLanguageAsync }  from '@/i18n';

export default {
    name: 'EurJoinUserStep3',
    computed: {
        ...mapGetters({
            langCd    : 'getLangCd'
        })
    },
    components: {
        'req-repair-info'  : reqRepairInfo
    },
    data() {
        return {
            userEmail: '',
            companyNo: '',
        };
    },
    computed: {
        ...mapGetters({
            loginId: 'getLoginId'
        }),
        getLoginId() { 
            return this.loginId || ''; 
        },
    },
    methods: {
        inputEvent() {
            var $inputs = $('form').find(':input');
            $inputs.each(function() {
                var $input = $(this),
                $label = $input.parent('div.one-input-container');
                if ($input.val())
                    $label.addClass('active');

                $input.focusin(function() {
                    $label.addClass('focus');
                    $label.siblings('div.flexbdy').addClass('off');
                });
                $input.change(function() {
                    $label.addClass('active');
                });
                $input.focusout(function() {
                    $label.removeClass('focus');
                    if (!$input.val()) $label.removeClass('active').siblings('div.flexbdy').removeClass('off');
                });
            });
        }
    },
    created() {
    },
    mounted() {
        $('body').addClass('reaair_wrap');
        if (!this.langCd) {
            this.langCd = localStorage.getItem('eur.user.lang.code');
        }
        store.commit('LANG_CD', this.langCd);
        loadLanguageAsync(this.langCd);

        this.$nextTick(() => {
            if (!SDLUtil.isEurLogin()) {
                SDLUtil.alert({
                    msg: 'MESSAGE.SESSION.HAS.EXPIRED',
                    onOkEvt: () => {
                        let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/requestRepairInfo`;
                        this.$router.push({ path: pathUrl, query: {}});
                    }
                });
            } else {
                this.inputEvent();
            }
        });
    },
    watch: {
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/JoinUserStep3.vue